import { ClientSideRender } from '@infl-ts/ui-advocate-components';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { DisplayQueryError } from '@infl-ts/util-query-errors';
import { Box, Drawer } from '@mui/material';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import { useState } from 'react';
import { ChallengePreview } from './codecs';
import Preview from './preview';
import Skeleton from './skeleton';
import { useChallengePreviewData } from './use-challenge-preview-data';
import { jsx as _jsx } from "react/jsx-runtime";

var PreviewRenderer = function PreviewRenderer() {
  var data = useChallengePreviewData();

  var _useState = useState(0),
      stageIndex = _useState[0],
      setStageIndex = _useState[1];

  return /*#__PURE__*/_jsx(Drawer, {
    open: true,
    transitionDuration: 0,
    anchor: "bottom",
    PaperProps: {
      style: {
        overflowX: 'hidden'
      }
    },
    "data-element": "Drawer",
    "data-component": "PreviewRenderer",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        height: '100vh'
      },
      "data-element": "Box",
      "data-component": "PreviewRenderer",
      "data-source-file": "index.tsx",
      children: pipe('loading' === data ? E.left(null) : E.right(data), E.match(function () {
        return /*#__PURE__*/_jsx(Skeleton, {});
      }, flow(function (data) {
        return ChallengePreview.decode(data !== null && data !== void 0 ? data : '');
      }, E.match(flow(makeDecodeError, function (err) {
        return /*#__PURE__*/_jsx(DisplayQueryError, {
          err: err,
          message: "Could not load challenge preview. Try again"
        });
      }), function (_ref) {
        var challenge = _ref.challenge,
            stages = _ref.stages;
        return /*#__PURE__*/_jsx(Preview, {
          challenge: challenge,
          stages: stages,
          stageIndex: stageIndex,
          setStageIndex: setStageIndex
        });
      }))))
    })
  });
};

export var ChallengePlayerPreview = function ChallengePlayerPreview() {
  return /*#__PURE__*/_jsx(ClientSideRender, {
    "data-element": "ClientSideRender",
    "data-component": "ChallengePlayerPreview",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(PreviewRenderer, {
      "data-element": "PreviewRenderer",
      "data-component": "ChallengePlayerPreview",
      "data-source-file": "index.tsx"
    })
  });
};